import { Web3Provider } from '@ethersproject/providers'

export default function getLibrary(provider: any): Web3Provider {
  const library = new Web3Provider(
    provider,
    typeof provider.networkId === 'number'
      ? provider.networkId
      : typeof provider.networkId === 'string'
      ? parseInt(provider.networkId)
      : 'any'
  )
  library.pollingInterval = 15_000
  return library
}
